import React from "react";
import type { ResponsiveValue, Theme, TLengthStyledSystem } from "styled-system";
import type { CtaButtonType } from "../../../../../../../common-deprecated/server/data/FormatBnbCtas";
import type { UseCtaButtonType } from "../../../../hooks/shared/actions/useCtaButton";
import useCtaButton from "../../../../hooks/shared/actions/useCtaButton";
import * as Button from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import ButtonPrimary from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonSecondary from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonSecondary";
import { useBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { Ellipsis } from "../../../../../../../common-deprecated/styles/v2/lexus/utilities/Ellipsis";

type CtaPropsType = {
    linkType: "primary" | "negative" | "light";
    config: CtaButtonType;
    children: React.ReactNode;
    darkIcon?: boolean;
    width?: ResponsiveValue<number, Theme<TLengthStyledSystem>>;
    linkWithoutIcon?: boolean;
};

type LinkPropsType = {
    linkType: CtaPropsType["linkType"];
    ctaProps: UseCtaButtonType;
    config: CtaButtonType;
    children: React.ReactNode;
    darkIcon?: boolean;
    width?: CtaPropsType["width"];
    linkWithoutIcon?: boolean;
};

const LinkComponent = ({ linkType, ctaProps, children }: LinkPropsType): JSX.Element | null => {
    const isMobile = useBreakpoint("down", "sm");
    if (linkType === "primary")
        return (
            <ButtonPrimary fullWidth linkWithoutIcon={isMobile} {...ctaProps}>
                <Ellipsis maxWidth="100%">{children}</Ellipsis>
            </ButtonPrimary>
        );
    if (linkType === "negative")
        return (
            <ButtonSecondary fullWidth linkWithoutIcon={isMobile} {...ctaProps}>
                {children}
            </ButtonSecondary>
        );
    if (linkType === "light")
        return (
            <Button.ButtonLightVariantWrapper>
                <ButtonPrimary fullWidth linkWithoutIcon={isMobile} {...ctaProps}>
                    {children}
                </ButtonPrimary>
            </Button.ButtonLightVariantWrapper>
        );
    return null;
};

// Ctas handled by GFI in useCtaButton
const HandledCtaButton = (props: CtaPropsType): JSX.Element | null => {
    const { linkType, config, children, darkIcon, width, linkWithoutIcon } = props;
    const ctaProps = useCtaButton(config);
    return (
        <LinkComponent
            linkType={linkType}
            ctaProps={ctaProps}
            config={config}
            darkIcon={darkIcon}
            width={width}
            linkWithoutIcon={linkWithoutIcon}
        >
            {children}
        </LinkComponent>
    );
};

const CtaButton = (props: CtaPropsType): JSX.Element | null => {
    return <HandledCtaButton {...props} />;
};

export default CtaButton;
